import React from 'react';
import * as StringUtil from 'app/common/lib/StringUtil';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import templateConst from 'app/common/lib/templateConst';

const styles = {
  tosContainer: {
    marginTop: '15px',
  },
  tosCommon: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    fontSize: '11px',
    fontWeight: 'normal',
    textAlign: 'center',
    WebkitTransition: 'opacity .2s linear',
    transition: 'opacity .2s linear',
  },
  tosLarge: {
    color: '#333',
    fontSize: '12px',
    lineHeight: '12px',
  },
  tosDark: {
    color: '#aaa',
    width: '224px',
  },
  tosLight: {
    color: 'rgba(255,255,255,0.9)',
    lineHeight: '150%',
    margin: '10px auto',
    textShadow: '0 1px rgba(0,0,0,0.18)',
    width: '272px',
  },
};

// lang: IM-2560 add strings for translation for the email. will remove
export function tempStringsToTranslate() {
  const subject = i18n._(
    'Your Pinterest account is now even more secure',
    '[urgent email] Subject for email to notify users of a change to their account”',
  );
  const body = i18n._(
    `To help keep your account and contact info even more secure, we're no longer allowing people to use their
    email address as their first or last name on Pinterest.

    We've removed the @domain.com from your name, but if you'd like to make any changes,
    you can update your name in the Profile section of your settings.

    For more information, visit our Help Center to learn about [account access and safety].
    https://help.pinterest.com/en/topics/account-access-and-safety

    Thanks for helping us keep Pinterest safe!`,
    '[urgent email] Body of email to notify users about a change to their account',
  );
  // this function is not used, this is to quiet linter
  return [subject, body];
}

export function TermsOfService(props, context) {
  const euCountries = templateConst.settings.EU_COUNTRIES;
  let tosStyles = { ...styles.tosCommon, ...styles.tosDark };
  if (!props.dark) {
    tosStyles = { ...styles.tosCommon, ...styles.tosLight };
  }
  let containerStyles = props.noContainer ? {} : styles.tosContainer;
  if (props.dynamicTopMargin) {
    containerStyles = { ...containerStyles, marginTop: '3%' };
  }
  if (props.disableWordBreak) {
    containerStyles = { ...containerStyles, hyphens: 'none' };
  }

  if (props.large) {
    tosStyles = { ...tosStyles, ...styles.tosLarge };
  }

  let tos;
  if (euCountries.indexOf(context.country) > -1) {
    tos = StringUtil.dangerouslyFormat(
      i18n._(
        "By continuing, you agree to Pinterest's " +
          '<a data-test-id="tos" href="{{ tos_url }}">Terms of Service</a>, ' +
          '<a data-test-id="privacy" href="{{ privacy_policy_url }}">Privacy Policy</a> and ' +
          '<a href="{{ cookie_url }}"> Cookie use</a>.',
      ),
      {
        tos_url: templateConst.settings.ABOUT_TERMS_PLAIN_URL,
        privacy_policy_url: templateConst.settings.ABOUT_PRIVACY_PLAIN_URL,
        cookie_url: templateConst.settings.ABOUT_COOKIE_URL,
      },
    );
  } else {
    tos = StringUtil.dangerouslyFormat(
      i18n._(
        'By continuing, you agree to Pinterest\'s <a data-test-id="tos" href="{{ tos_url }}" target="_blank" >' +
          'Terms of Service</a>, <a data-test-id="privacy" href="{{ privacy_policy_url }}" target="_blank">' +
          'Privacy Policy</a>',
      ),
      {
        tos_url: templateConst.settings.ABOUT_TERMS_PLAIN_URL,
        privacy_policy_url: templateConst.settings.ABOUT_PRIVACY_PLAIN_URL,
      },
    );
  }

  return (
    <div style={containerStyles}>
      <span className={props.dark ? '' : 'TermsOfService__light'} style={tosStyles}>
        {/* eslint-disable  react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: tos }} />
        {/* eslint-enable  react/no-danger */}
      </span>
    </div>
  );
}

TermsOfService.propTypes = {
  dark: PropTypes.bool,
  large: PropTypes.bool,
  noContainer: PropTypes.bool,
  dynamicTopMargin: PropTypes.bool,
  disableWordBreak: PropTypes.bool,
};

TermsOfService.contextTypes = {
  country: PropTypes.string.isRequired,
};

export default TermsOfService;
